import React, { useContext } from "react";
import { UserContext } from "../Context/UserContext";
import vazronLogo from "../../assets/vazron_logo.png";

export default function Home() {
  const { darkTheme, loginData } = useContext(UserContext);
  return (
    <div>
      <div className="flex h-[400px] items-center justify-center">
        <div>
          <img src={vazronLogo} className="w-52" />
          <div className="text-center">
            <div className="text-lg">Welcome to Vazron</div>
            <p className="text-gray-400">Inventory- Dashboard</p>
            <div>
              Hello, <span className="text-blue-500">{loginData.name}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-2 right-2 bg-[#ccd] pl-6 rounded-xl pr-2 py-1">
        <ul className="list-disc">
          <div className="my-2">Short-Cut Keys</div>
          <li>shift + D (direct-po-create)</li>
          <li>shift + I (indent-create)</li>
          <li>shift + G (generate-enquiry)</li>
          <li>shift + E (view-enquiry)</li>
          <li> shift + Q (view-quotation)</li>
          <li>shift + C (compare-quotation)</li>
        </ul>
      </div>
    </div>
  );
}
